<template>
<div class="content">
  <div class="header">
    <el-select size="mini" placeholder="催缴类型" :disabled="urge_type!==0" clearable v-model="where2.urge_type">
      <el-option :value="1" label="自催"></el-option>
      <el-option :value="2" label="诉讼"></el-option>
      <el-option :value="5" label="项目自催"></el-option>
      <el-option :value="3" label="第三方管理"></el-option>
      <el-option :value="4" label="第三方诉讼"></el-option>
    </el-select>
    <el-select size="mini" placeholder="账龄类型" clearable v-model="where2.age">
      <el-option v-if="[1].includes(urge_type)||urge_type===0" :value="1" label="当期"></el-option>
      <el-option v-if="[1].includes(urge_type)||urge_type===0" :value="2" label="纯上一年"></el-option>
      <el-option v-if="[2,3,4,5].includes(urge_type)||urge_type===0" :value="3" label="1年以上2年以内"></el-option>
      <el-option v-if="[2,3,4,5].includes(urge_type)||urge_type===0" :value="4" label="2年以上"></el-option>
<!--      <el-option :value="5" label="1年以上"></el-option>-->
    </el-select>
    <el-date-picker
      style="width: 120px"
      v-model="where2.jh_time"
      size="mini"
      type="month"
      format="yyyy-MM"
      value-format="yyyy-MM" placeholder="计划催费月份">
    </el-date-picker>
<!--    <el-date-picker-->
<!--      style="width: 120px"-->
<!--      v-model="where2.qf_time"-->
<!--      size="mini"-->
<!--      type="month"-->
<!--      format="yyyy-MM"-->
<!--      value-format="yyyy-MM" placeholder="欠费月份">-->
<!--    </el-date-picker>-->
    <el-date-picker
      style="width: 120px"
      v-model="where2.qf_start_month"
      size="mini"
      type="month"
      format="yyyy-MM"
      value-format="yyyy-MM" placeholder="欠费起始月">
    </el-date-picker>
    <el-date-picker
      style="width: 120px"
      v-model="where2.qf_end_month"
      size="mini"
      type="month"
      format="yyyy-MM"
      value-format="yyyy-MM" placeholder="欠费截止月">
    </el-date-picker>
    <el-date-picker
      style="width: 150px"
      v-model="where2.gj_time"
      size="mini"
      type="date"
      format="yyyy-MM-dd"
      value-format="yyyy-MM-dd" placeholder="跟进日期">
    </el-date-picker>
<!--    <el-select size="mini" placeholder="催费次数" clearable v-model="where2.type">-->
<!--      <el-option :value="0" label="暂未催费"></el-option>-->
<!--      <el-option :value="1" label="1次催费"></el-option>-->
<!--      <el-option :value="2" label="2次催费"></el-option>-->
<!--      <el-option :value="3" label="3次催费"></el-option>-->
<!--      <el-option :value="4" label="多次催费"></el-option>-->
<!--    </el-select>-->
    <el-input clearable placeholder="欠费月数" v-model="where2.month_count" style="width: 100px" size="mini"></el-input>
    <el-select size="mini" placeholder="月催费次数" clearable v-model="where2.cur_month_times" style="width: 120px;">
      <el-option :value="0" label="暂未催费"></el-option>
      <el-option :value="1" label="1次催费"></el-option>
      <el-option :value="2" label="2次催费"></el-option>
      <el-option :value="3" label="3次催费"></el-option>
      <el-option :value="4" label="多次催费"></el-option>
    </el-select>
    <el-select size="mini" placeholder="年催费次数" clearable v-model="where2.cur_year_times" style="width: 120px;">
      <el-option :value="0" label="暂未催费"></el-option>
      <el-option :value="1" label="1次催费"></el-option>
      <el-option :value="2" label="2次催费"></el-option>
      <el-option :value="3" label="3次催费"></el-option>
      <el-option :value="4" label="多次催费"></el-option>
    </el-select>
    <el-select size="mini" placeholder="选择房态" clearable v-model="where2.room_status" style="width: 120px;">
      <el-option :value="1" label="空置"></el-option>
      <el-option :value="2" label="未领"></el-option>
      <el-option :value="3" label="空关"></el-option>
      <el-option :value="4" label="装修"></el-option>
      <el-option :value="5" label="入住"></el-option>
      <el-option :value="6" label="出租"></el-option>
      <el-option :value="7" label="停用"></el-option>
    </el-select>
    <el-select size="mini" placeholder="欠费类型" clearable v-model="where2.arrears_level1" style="width: 180px;" @change="changeArrearsLevel1">
      <el-option v-for="(item, index) in arrears_arr" :key="index" :value="item.id" :label="item.name"></el-option>
    </el-select>
    <el-select size="mini" placeholder="欠费类型-原因" clearable v-model="where2.arrears_level2" style="width: 180px;">
      <el-option v-for="(item, index) in arrears_arr_children" :key="index" :value="item.id" :label="item.name"></el-option>
    </el-select>

    <el-input clearable placeholder="输入房产" v-model="where2.house_name" style="width: 200px" size="mini"></el-input>
    <el-button size="mini" v-if="ERP.isPermission(8007001007)" @click="exportExcel(3)">导出计划催费房产</el-button>
  </div>
<!--  <div class="header" style="margin-top: 10px;justify-content: flex-end">-->
<!--    <el-button type="danger" size="mini" @click="delHouseIds()">批量移除</el-button>-->
<!--    <el-button type="primary" size="mini" @click="houseLegalToTempByHouseIds()">批量添加</el-button>-->
<!--    <el-button type="primary" size="mini" @click="houseLegalToTemp()">全部添加</el-button>-->
<!--    <el-button size="mini" @click="exportExcel(1)">导出房产（所有房产）</el-button>-->
<!--    <el-button size="mini" @click="exportExcel(2)">导出房产（催缴房产）</el-button>-->
<!--    <el-button size="mini" @click="importLegalHouseExcel">导入催缴房产</el-button>-->
<!--  </div>-->
  <div>
    <header-tip>
      催费项目数：{{pageData.project_count}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      催费房产数：{{pageData.total}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </header-tip>
    <header-tip v-if="pageData.use_yaer_count>0">
      年度已催房产：{{pageData.use_yaer_count}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      年度催缴房产覆盖率：{{useYaerRate}} %&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      月度已催房产：{{pageData.use_month_count}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      月度催缴房产覆盖率：{{useMonthRate}} %&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </header-tip>
  </div>

  <AgeTip
    :project_id="reginWhere.project_name"
    :project_ids="reginWhere.project_ids"
    :ages="[1,2]"
    :yearmonth="where2.jh_time"
  ></AgeTip>
  <div class="header-tip" v-if="selectCount>0">
    <span v-if="selectCount>0">选择房产数：{{selectCount}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
    <span v-if="selectDebtAmount>0">欠费金额：{{formatMoney(selectDebtAmount,2)}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
    <span v-if="selectLawsuitAmount>0">诉讼金额：{{formatMoney(selectLawsuitAmount,2)}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
    <span v-if="selectCount1>0">自催户数：{{selectCount1}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
    <span v-if="selectCount2>0">诉讼户数：{{selectCount2}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
    <span v-if="selectCount5>0">项目自催户数：{{selectCount5}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
    <span v-if="selectCount3>0">第三方管理户数：{{selectCount3}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
    <span v-if="selectCount4>0">第三方诉讼户数：{{selectCount4}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
  </div>
  <div class="body">
    <div>
      <div class="table-wrap">
        <el-table
          v-loading="loading"
          v-if="pageData" :data="pageData.list"
          border
          style="width: 100%" height="60vh" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="45" fixed></el-table-column>
          <el-table-column
            prop="房产信息"
            label="房产信息" width="320" fixed></el-table-column>
          <el-table-column
            prop="区域"
            label="区域"
            width="90">
          </el-table-column>
          <el-table-column
            prop="业主"
            label="业主姓名"
            width="100">
          </el-table-column>
          <el-table-column
            prop="业主电话"
            label="业主电话"
            width="150">
          </el-table-column>
          <el-table-column
            prop="房态"
            label="房态"
            width="100">
          </el-table-column>
          <el-table-column
            label="银行划扣"
            width="90">
            <template slot-scope="scope">
              <span style="color: #328628" v-if="scope.row.bankType">是</span>
              <span v-if="!scope.row.bankType"></span>
            </template>
          </el-table-column>
          <el-table-column
            prop="欠费起始月份"
            label="欠费起始月份"
            width="120">
          </el-table-column>
          <el-table-column
            prop="欠费月数"
            label="欠费月数"
            width="100">
          </el-table-column>
          <el-table-column
            prop="欠费金额/诉讼金额"
            label="欠费金额/诉讼金额"
            width="140">
            <template slot-scope="scope">
              <el-link v-if="scope.row['催缴类型']!=='诉讼'" type="primary" size="mini" @click="getHouseBill(scope.row)">{{ scope.row['欠费金额'] }}</el-link>
              <span v-if="scope.row['催缴类型']==='诉讼'">{{scope.row['诉讼金额']}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="计划催缴月份"
            label="计划催缴月份"
            width="100">
          </el-table-column>
          <el-table-column
            prop="催缴类型"
            label="催缴类型"
            width="90">
          </el-table-column>
          <el-table-column
            prop="账龄类型"
            label="账龄类型"
            width="90">
          </el-table-column>
          <el-table-column
            prop="第三方合作单位"
            label="第三方合作单位"
            width="150">
          </el-table-column>
          <el-table-column
            prop="缴费类型"
            label="缴费类型"
            width="90">
          </el-table-column>
<!--          <el-table-column-->
<!--            prop="上次缴费时间"-->
<!--            label="上次缴费时间"-->
<!--            width="170">-->
<!--            <template slot-scope="scope">-->
<!--              <el-link type="primary" size="mini" @click="getLastHouseBill(scope.row)">{{ scope.row['上次缴费时间'] }}</el-link>-->
<!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column
            prop="上次成功缴费方式"
            label="上次成功缴费方式"
            width="200">
          </el-table-column>
          <el-table-column
            prop="上次缴费时间"
            label="上次缴费时间"
            width="170"></el-table-column>
<!--          <el-table-column-->
<!--            prop="第一次催费时间"-->
<!--            label="第一次催费时间"-->
<!--            width="150">-->
<!--          </el-table-column>-->
<!--          <el-table-column-->
<!--            prop="第二次催费时间"-->
<!--            label="第二次催费时间"-->
<!--            width="150">-->
<!--          </el-table-column>-->
<!--          <el-table-column-->
<!--            prop="第三次催费时间"-->
<!--            label="第三次催费时间"-->
<!--            width="150">-->
<!--          </el-table-column>-->

          <el-table-column
            prop="one_gj_time"
            label="第一次催费跟进时间"
            width="150">
          </el-table-column>
          <el-table-column
            prop="two_gj_time"
            label="第二次催费跟进时间"
            width="150">
          </el-table-column>
          <el-table-column
            prop="three_gj_time"
            label="第三次催费跟进时间"
            width="150">
          </el-table-column>


<!--          <el-table-column-->
<!--            prop="催费次数"-->
<!--            label="催费次数"-->
<!--            width="90">-->
<!--          </el-table-column>-->
          <el-table-column
            prop="cur_month_times"
            label="月催费次数"
            width="90">
          </el-table-column>
          <el-table-column
            prop="cur_year_times"
            label="年催费次数"
            width="90">
          </el-table-column>
          <el-table-column
            prop="欠费类型"
            label="欠费类型"
            width="150">
            <template slot-scope="scope">
              <span v-if="scope.row['欠费类型']">{{scope.row['欠费类型']}}</span>
              <span v-if="scope.row['欠费类型原因']"> ： {{scope.row['欠费类型原因']}}</span>
            </template>
          </el-table-column>
<!--          <el-table-column-->
<!--            prop="欠费原因"-->
<!--            label="欠费原因"-->
<!--            width="150">-->
<!--          </el-table-column>-->
          <el-table-column
            prop="业主诉求"
            label="业主诉求"
            width="150">
          </el-table-column>
          <el-table-column
            prop="解决措施"
            label="催费措施"
            width="150">
          </el-table-column>
          <el-table-column
            prop="备注"
            label="备注"
            width="200">
          </el-table-column>
          <el-table-column
            label="审批流程"
            width="200">
            <template slot-scope="scope">
              <el-link v-if="scope.row.one_task_id" type="primary" size="mini" @click="openFlow(scope.row.one_task_id)">审批流程1</el-link>
              <el-link v-if="scope.row.two_task_id" type="primary" size="mini" @click="openFlow(scope.row.two_task_id)">审批流程2</el-link>
            </template>
          </el-table-column>
<!--          <el-table-column-->
<!--            label="操作"-->
<!--            width="100" fixed="right">-->
<!--            <template slot-scope="scope">-->
<!--&lt;!&ndash;              <el-button type="primary" size="mini" @click="editType(scope.row)">变更催缴</el-button>&ndash;&gt;-->
<!--&lt;!&ndash;              <el-link type="primary" @click="openFlow(scope.row)">审批流程</el-link>&nbsp;&nbsp;&nbsp;&nbsp;&ndash;&gt;-->
<!--              <el-button type="danger" size="mini" @click="delHouse(scope.row)">移除</el-button>-->

<!--            </template>-->
<!--          </el-table-column>-->
        </el-table>
      </div>
      <div class="pagination-wrap">
        <el-pagination
          background
          layout="sizes,total,prev, pager, next"
          :total="pageData.total*1"
          :page-size="pageData.pageSize*1"
          :current-page="pageData.page*1"
          @current-change="pageChange"
          @size-change="handleSizeChange"
          :page-sizes="[15,20,50,100, 200, 300, 400,500,1000]"
        ></el-pagination>
      </div>
    </div>
    <el-dialog title="修改催缴类型" :visible.sync="dialogVisible" :close-on-click-modal="false" @close="onClose" width="600px">

      <div class="view-file-win">
        <el-descriptions class="margin-top" :column="1" size="mini" border>
          <el-descriptions-item label="房产信息">{{ from_data['房产信息'] }}</el-descriptions-item>
          <el-descriptions-item label="区域">{{ from_data['区域'] }}</el-descriptions-item>
          <el-descriptions-item label="欠费金额">{{ from_data['欠费金额'] }}</el-descriptions-item>
          <el-descriptions-item label="催缴类型">
            <el-select placeholder="催缴类型" v-model="from_data['催缴类型']">
              <el-option value="自催" label="自催"></el-option>
              <el-option value="诉讼" label="诉讼"></el-option>
              <el-option value="第三方" label="第三方"></el-option>
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item label="计划催缴月份">
            <el-date-picker
              style="width: 150px"
              v-model="from_data['计划催缴月份']"
              size="mini"
              type="month"
              format="yyyy-MM"
              value-format="yyyy-MM">
            </el-date-picker>
          </el-descriptions-item>
          <el-descriptions-item label="账龄类型">{{ from_data['账龄类型'] }}</el-descriptions-item>
          <el-descriptions-item label="欠费类型">{{ from_data['欠费类型'] }}</el-descriptions-item>
<!--          <el-descriptions-item label="欠费原因">{{ from_data['欠费原因'] }}</el-descriptions-item>-->
          <el-descriptions-item label="业主诉求">{{ from_data['业主诉求'] }}</el-descriptions-item>
        </el-descriptions>
      </div>
      <template slot="footer">
        <div>
          <el-button @click="onClose">关 闭</el-button>
          <el-button @click="editTypeSubmit">修 改</el-button>
        </div>
      </template>
    </el-dialog>



    <el-dialog title="最后一次缴费明细" :visible.sync="dialogVisible_2" :close-on-click-modal="false" width="600px">

      <div class="view-file-win">
        <el-descriptions class="margin-top" :column="1" size="mini" border>
          <el-descriptions-item label="房产信息">{{ house_bill_order_2['房产信息'] }}</el-descriptions-item>
          <el-descriptions-item label="区域">{{ house_bill_order_2['区域'] }}</el-descriptions-item>
          <el-descriptions-item label="欠费金额">{{ house_bill_order_2['欠费金额'] }}</el-descriptions-item>
          <el-descriptions-item label="账龄类型">{{ house_bill_order_2['账龄类型'] }}</el-descriptions-item>
          <el-descriptions-item label="欠费类型">{{ house_bill_order_2['欠费类型'] }}</el-descriptions-item>
<!--          <el-descriptions-item label="欠费原因">{{ house_bill_order_2['欠费原因'] }}</el-descriptions-item>-->
          <el-descriptions-item label="业主诉求">{{ house_bill_order_2['业主诉求'] }}</el-descriptions-item>
        </el-descriptions>
      </div>
      <template slot="footer">
        <div>
          <el-button @click="dialogVisible_2=false">关 闭</el-button>
        </div>
      </template>
    </el-dialog>

  </div>
  <ViewFile ref="ViewFile" />
  <ViewFlow ref="viewFlowRef" />
  <LegalHouseMoneyList ref="legalHouseMoneyListRef" />
</div>
</template>

<script>
import Http from "../../common/Http";
import moment from "moment/moment";
import ViewFile from "../../../Common/ViewFile";
import Track from "../../../../../assets/js/trackHttp";
import {CommonHelp} from "../../common/CommonHelp";
import ViewFlow from "../../../Common/ViewFlow";
import ButlerHttp from "../../common/ButlerHttp";
import AgeTip from "../common/AgeTip";
import LegalHouseMoneyList from "../LegalHouseMoneyList";
import HeaderTip from "../../../Common/header-tip";

export default {
  name: "LegalHousePlan",
  components: {HeaderTip, LegalHouseMoneyList, AgeTip, ViewFlow, ViewFile},
  props:{
    urge_type:{
      type: Number,
      default(){
        return 0
      }
    },
  },
  inject:['where','reginWhere'],
  data(){
    return{
      where2:{
        urge_type:"",
        // urge_types:"1,2",
        age:(!this.$auth.isRole('75,182,371,392,437,71'))?"":(this.$auth.isRole('75,182,371,392,437')?1:3),
        type:"",
        cur_month_times:"",
        cur_year_times:"",
        qf_time:moment().format("YYYY-MM"),
        qf_start_month:"",
        qf_end_month:"",
        jh_time:'',//moment().format("YYYY-MM"),
        house_name:"",
        room_status:"",
        arrears_level1:'',
        arrears_level2:'',
        gj_time:"",
        month_count:"",
      },
      loading:false,
      pageData:{
        list: [],
        total: 0,
        pageSize: 20,
        page: 1,
      },
      from_data:{},
      dialogVisible:false,
      dialogVisible_2:false,
      house_bill_order_2:{},
      multipleSelection:[],
      arrears_arr:[],
      arrears_arr_children:[],
    }
  },
  mounted() {
    const that=this;
    if(that.urge_type){
      that.where2.urge_type = that.urge_type;
      that.where2.age = "";
    }
    this.pageChange(1);
    this.getArrearsArr();
  },
  watch:{
    "reginWhere.type_id":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "reginWhere.project_region":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "reginWhere.project_name":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "reginWhere.area_id":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.age":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.type":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.urge_type":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.qf_time":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.qf_start_month":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.qf_end_month":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.cur_month_times":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.cur_year_times":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.room_status":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.arrears_level1":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.arrears_level2":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.jh_time":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.house_name":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.gj_time":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.month_count":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
  },
  computed:{
    ch_md5s(){
      return this.multipleSelection.map(ret=>ret.ch_md5)
    },
    selectCount(){
      return this.multipleSelection.length
    },
    selectCount1(){
      return this.multipleSelection.filter(ret=>ret['催缴类型']==='自催').length
    },
    selectCount2(){
      return this.multipleSelection.filter(ret=>ret['催缴类型']==='诉讼').length
    },
    selectCount3(){
      return this.multipleSelection.filter(ret=>ret['催缴类型']==='第三方管理').length
    },
    selectCount4(){
      return this.multipleSelection.filter(ret=>ret['催缴类型']==='第三方诉讼').length
    },
    selectCount5(){
      return this.multipleSelection.filter(ret=>ret['催缴类型']==='项目自催').length
    },
    selectDebtAmount(){
      return this.multipleSelection.reduce((acc,cur)=>{
        return acc+((cur['欠费金额']||0)*1)
      },0)
    },
    selectLawsuitAmount(){
      return this.multipleSelection.reduce((acc,cur)=>{
        return acc+((cur['诉讼金额']||0)*1)
      },0)
    },
    useYaerRate(){
      return this.pageData.total?(Math.round(this.pageData.use_yaer_count/this.pageData.total*10000)/100):0;
    },
    useMonthRate(){
      return this.pageData.total?(Math.round(this.pageData.use_month_count/this.pageData.total*10000)/100):0;
    }
  },
  methods:{
    getList(){
      const that = this;
      that.loading = true;
      let where = {
        ...that.where2,
        project_ids:typeof that.reginWhere.project_ids==="string"?that.reginWhere.project_ids:'',
        project_id:that.reginWhere.project_name,
        area_id:that.reginWhere.area_id
      }

      ButlerHttp.post("Legal/getLegalHouseList", {
        ...where,
        page: that.pageData.page,
        pageSize: that.pageData.pageSize
      }, res => {
        if (res.code) {
          res.data.list.map(ret => {
            // ret.is_invoice=ret.is_invoice === 1;
            // ret.is_paid=ret.is_paid === 1;
            return ret;
          });
          that.pageData = res.data;
        }
        that.loading = false;
      });
    },
    pageChange(i) {
      const that=this;
      that.pageData.page = i;
      CommonHelp.debounce(()=>{
        that.getList()
      },500,that);

    },
    getArrearsArr(){
      const that=this;
      ButlerHttp.get("Legal/getArrearsArr",{},ret=>{
        if(ret.code){
          that.arrears_arr=ret.data;
        }
      })
    },
    handleSizeChange(i){
      this.pageData.pageSize = i;
      this.pageChange(1);
    },
    exportExcel(type=1) {
      const that = this;
      console.log(that.reginWhere.project_name)
      if(!that.reginWhere.project_name){
        that.$message.error("请选择项目")
        return false
      }
      const loading=that.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let where = {
        project_ids:that.reginWhere.project_ids,
        project_id:that.reginWhere.project_name
      }
      if(type===2||type===3){
        where={
          ...where,
          ...that.where2,
          area_id:that.reginWhere.area_id
        }
      }

      let urlObj={
        1:"Legal/getLegalHouseExcel2",
        2:"Legal/getLegalHouseExcel",
        3:"LegalHouse/getLegalHouseExcel"
      }

      ButlerHttp.post(urlObj[type], {
        ...where
      }, res => {
        loading.close();
        if (res.code) {
          that.$refs.ViewFile.show({
            width: '90vw',
            height: '80vh',
            title: "文件预览",
            src: __HTTP__.defaults.baseURL + res.data,
            download() {
              window.open(__HTTP__.defaults.baseURL + res.data);
            }
          });
        } else {
          that.$message.error(res.msg);
        }
      });
    },
    importLegalHouseExcel(){
      const that=this;
      Http.uploadFile(file=>{
        const loading=that.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        ButlerHttp.post("Legal/importLegalHouseToFlow", {
          file: file
        }, res => {
          loading.close();
          if (res.code) {
            let timeStr = new Date().getTime();
            ERP.navigateTo(`/flow/FlowView?sheet_id=140&master_id=114&timeValue=${timeStr}&batch_number=${res.data}`);
            // that.pageChange(1);
          } else {
            that.$message.error(res.msg);
          }
        });
      })
    },
    editType(item){
      const that=this;
      that.from_data=item;
      that.dialogVisible=true;
    },
    onClose(){
      this.dialogVisible=false;
      this.from_data={}
    },
    houseLegalToTempByHouseIds(){
      const that=this;
      if(!that.reginWhere.project_name){
        that.$message.error('请选择项目！');
        return false
      }
      if(!that.ch_md5s.length){
        that.$message.error('请勾选房产！');
        return false
      }
      that.loading = true;
      ButlerHttp.post("LegalHouse/houseLegalToTempByHouseIds",{
        projectId:that.reginWhere.project_name,
        ch_md5s:that.ch_md5s.join(','),
      }, res => {
        that.loading = false;
        if (res.code) {
          that.$message.success("操作成功")
          that.$emit("onAdd",{})
        } else {
          that.$message.error(res.msg);
        }
      });
    },
    houseLegalToTemp(){
      const that=this;
      if(!that.reginWhere.project_name){
        that.$message.error('请选择项目！');
        return false
      }
      let where = {
        ...that.where2,
        project_ids:typeof that.reginWhere.project_ids==="string"?that.reginWhere.project_ids:'',
        project_id:that.reginWhere.project_name,
        area_id:that.reginWhere.area_id
      }
      that.loading = true;
      ButlerHttp.post("LegalHouse/houseLegalToTemp",{
        ...where,
      }, res => {
        that.loading = false;
        if (res.code) {
          that.$emit("onAdd",{})
        }else {
          that.$message.error(res.msg);
        }
      });
    },
    editTypeSubmit(){
      const that=this;
      let urge_type_obj={
        '自催':1,
        '诉讼':2,
        '第三方':3
      }
      ButlerHttp.post("Legal/updateLegalHouseType", {
        id: that.from_data.id,
        ch_md5: that.from_data.ch_md5,
        urge_type: urge_type_obj[that.from_data['催缴类型']],
        year_month: that.from_data['计划催缴月份']
      }, res => {
        if (res.code) {
          that.onClose();
          that.$message.success("操作成功");
          that.pageChange(1);
        } else {
          that.$message.error(res.msg);
        }
      });
    },
    getHouseBill(item){
      const that=this;
      // projectId: item.PrecinctID,
      //   houseId: item.HouseID
      that.$refs.legalHouseMoneyListRef.show({
        project_id:item.PrecinctID,
        house_id:item.HouseID,
      })

    },
    getLastHouseBill(item){
      const that=this;
      ButlerHttp.post("Legal/getLastHouseBill", {
        projectId: item['项目ID'],
        houseId: item['房产ID'],
        last_time: item['上次缴费时间']
      }, res => {
        if (res.code) {
          that.dialogVisible_2 = true;
          that.house_bill_order_2 = res.data;
        } else {
          that.$message.error(res.msg);
        }
      });
    },
    delHouse(item){
      const that=this;
      that.$confirm(`您将要移除该【${item['房产信息']}】欠费房产，移除后将不再显示该房产的欠费计划，包含自催、诉讼和第三方管理。您确定操作吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        ButlerHttp.post("Legal/delHouseUrge", {
          projectId: item['项目ID'],
          ch_md5: item.ch_md5
        }, res => {
          if (res.code) {
            that.$message.success(res.msg);
            that.getList();
          } else {
            that.$message.error(res.msg || '操作异常');
          }
        });
      })
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    delHouseIds(){
      const that=this;
      if(!that.reginWhere.project_name){
        that.$message.error('请选择项目！');
        return false
      }
      if(!that.ch_md5s.length){
        that.$message.error('请勾选房产！');
        return false
      }
      that.$confirm(`您将要移除这些欠费房产，移除后将不再显示该房产的欠费计划，包含自催、诉讼和第三方管理。您确定操作吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        ButlerHttp.post("Legal/delHouseUrge", {
          projectId: that.reginWhere.project_name,
          ch_md5s: that.ch_md5s.join(',')
        }, res => {
          if (res.code) {
            that.$message.success(res.msg);
            that.getList();
          } else {
            that.$message.error(res.msg || '操作异常');
          }
        });
      })
    },
    openFlow(task_id){
      const that = this;
      if(!task_id){
        that.$message.error('没有审批流程')
        return;
      }
      that.$refs.viewFlowRef.show({task_id:task_id})
    },
    changeArrearsLevel1(id){
      const that=this;
      let arrears_index=that.arrears_arr.findIndex(ret=>ret.id===id)
      if(arrears_index!==-1){
        that.arrears_arr_children=that.arrears_arr[arrears_index].children||[];
        that.where2.arrears_level2='';
      }else {
        that.arrears_arr_children=[];
        that.where2.arrears_level2='';
      }
    },
  }
}

</script>

<style lang="scss" scoped>
@import "../../common";
.content{
  min-height: calc(100vh - 350px);

  .header-tip{
    margin: 5px 0;
    padding: 5px 10px;
    background-color: #f56c6c;
    color: #FFFFFF;
    border-radius: 4px;
    display: inline-block;
  }
  .pagination-wrap{
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/plan/LegalHousePlan.vue